import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Playground from "../views/Playground.vue";
import Cart from "../views/Cart.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Nouveautés",
		component: Home,
	},
	{
		path: "/cart",
		name: "Panier",
		component: Cart,
	},
	{
		path: "/contact",
		name: "Contact",
		component: About,
	},
	{ path: "*", component: NotFound },
];

if (process.env.NODE_ENV === "development") {
	routes.push({
		path: "/playground",
		name: "Playground",
		component: Playground,
	});
}

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
